var InsuletStatusCode;
(function (InsuletStatusCode) {
    InsuletStatusCode[InsuletStatusCode["SUCCESS"] = 0] = "SUCCESS";
    InsuletStatusCode[InsuletStatusCode["CID_ALREADY_USED"] = 30] = "CID_ALREADY_USED";
    InsuletStatusCode[InsuletStatusCode["WRONG_REGION"] = 60] = "WRONG_REGION";
    InsuletStatusCode[InsuletStatusCode["INTERNAL_ERROR"] = 15] = "INTERNAL_ERROR";
    InsuletStatusCode[InsuletStatusCode["FORGOT_PASSWORD"] = 50] = "FORGOT_PASSWORD";
    InsuletStatusCode[InsuletStatusCode["LOCKOUT_ERROR"] = 45] = "LOCKOUT_ERROR";
})(InsuletStatusCode || (InsuletStatusCode = {}));
export default InsuletStatusCode;
